class Constants {
    // module actions
    static ACT_READ = 'R'
    static ACT_CREATE = 'W'
    static ACT_DELETE = 'D'
    static ACT_EXECUTE = 'X'
}
export default Constants